module.exports = __webpack_public_path__ + "static/media/Brochure2.1e0d54f5.pdf";